import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateMacroLinked = api(async function updateMacroLinked({ id, linked }) {
    if (!id) return false
    return mutate(
        gql`
            mutation UpdateMacroLinked($id: String!, $linked: [String!]) {
                updateMacroLinked(id: $id, linked: $linked)
            }
        `,
        { id, linked },
        { returns: "updateMacroLinked" }
    )
})
